import { type FC } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withExperiments } from '@wix/wix-experiments-react';
import { endModuleLoad, startModuleLoad } from '../../redux/actions';
import { selectIsAppLoading } from '../../redux/selectors';
import { type IPayAppComponentProps } from '../../types/PayApp';
import { PayAppComponent } from './PayAppComponent';

const mapStateToProps = (state) => ({
  isLoading: selectIsAppLoading(state),
});

const composeComponent = compose(
  connect(mapStateToProps, {
    startModuleLoad,
    endModuleLoad,
  }),
  withExperiments,
);

export default composeComponent(
  // @ts-expect-error TODO[fix][p=0] allowManualPayment has conflict, figure out what to do with it
  PayAppComponent,
) as FC<IPayAppComponentProps>;
